import { useState } from "react";
import Link from "./Link";
import { Tooltip } from "ui/popovers/Tooltip";

export function Wrapper({ children }) {
  return <Tooltip.Provider>{children}</Tooltip.Provider>;
}

<Wrapper>

## Basic Usage

<Link href="#">Click me</Link>

---

## Link Types

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <Link href="https://example.com">External link (href)</Link>
  <Link onClick={() => alert("Clicked!")}>Action link (onClick)</Link>
  <Link href="https://example.com" onClick={() => console.log("clicked")}>
    Both href and onClick
  </Link>
</div>

---

## States

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <Link href="#">Normal</Link>
  <Link href="#" selected>
    Selected
  </Link>
  <Link href="#" disabled>
    Disabled
  </Link>
</div>

---

## With Tooltip

<div style={{ display: "flex", gap: "1rem" }}>
  <Link href="#" tooltip="This is helpful information">
    Hover for tooltip
  </Link>
</div>

---

## Navigation Menu Example

export function NavigationExample() {
  const [current, setCurrent] = useState("home");
  const items = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "services", label: "Services" },
    { id: "contact", label: "Contact" },
  ];
  return (
    <nav style={{ display: "flex", gap: "1rem" }}>
      {items.map((item) => (
        <Link key={item.id} selected={current === item.id} onClick={() => setCurrent(item.id)}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
}

<NavigationExample />

---

## Disabled with Title

<Link disabled title="This feature is not available">
  Unavailable Feature
</Link>

Hover to see the title tooltip on disabled links.

---

## In Text Context

<p>
  Learn more about our <Link href="#">privacy policy</Link> and <Link href="#">terms of service</Link>.
</p>

</Wrapper>


